export default __webpack_public_path__ + "static/videoposter-6b3a39481e9fb6fb2fd24ad3f8aeb0fe.jpeg";